<template>
  <BModal
    id="modalDelete"
    ref="modalDelete"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        class="m-auto"
      >
      <div class="font-semibold text-2xl text-black my-1">
        Anda yakin untuk menghapus data ini ?
      </div>
      <p class="text-black">
        Data User yang dipilih akan terhapus bila anda menekan “Hapus”. Yakin ingin menghapus data ini ?
      </p>
      <div class="flex justify-center mt-3">
        <BButton
          size="md"
          variant="outline-primary"
          class="mr-1"
          style="width: 160.5px"
          @click="$bvModal.hide('modalDelete')"
        >
          Batal
        </BButton>
        <BButton
          :disabled="loading"
          size="md"
          variant="primary"
          style="width: 160.5px"
          block
          @click="onFinish"
        >
          <BSpinner
            v-if="loading"
            small
          />
          Hapus
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'

export default {
  name: 'ModalDelete',
  props: {
    idItem: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      alertSuccess,
      alertError,
    }
  },
  methods: {
    async onFinish() {
      this.loading = true
      const url = `/v1/user_access/${this.idItem}/delete`
      await komtimAxiosIns.delete(url)
        .then(res => {
          const text = 'Berhasil menghapus data'
          this.alertSuccess(text)
          this.loading = false
          this.$bvModal.hide('modalDelete')
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
        .finally(() => this.$emit('deleted'))
    },
  },
}
</script>
